import PropTypes from 'prop-types';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} Snack
 */
export default PropTypes.shape({
  id: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.string,
    timeout: PropTypes.number,
    buttonTemplate: PropTypes.string,
    button: PropTypes.shape({
      label: PropTypes.string,
      action: PropTypes.func
    })
  })
});



// WEBPACK FOOTER //
// ./app/propTypes/snack.js